import { typography } from "../settings/settingsListDesign";
import { Statistic } from "../ui";
import React from "react";
import { spacing } from "../settings/settingsListDesign";

export type StatCardContentProps = {
  /** Titel über der Zahl (z. B. "Mitglieder", "offene Posten") */
  title: React.ReactNode;
  /** Hauptwert (Zahl oder formatierter Betrag) */
  value: React.ReactNode;
  /** Optional: Suffix hinter dem Wert (z. B. "/ 10", "Konten") */
  suffix?: React.ReactNode;
  /** Optional: Zusätzliche Zeile unter der Statistik (z. B. Summen, Hinweise) */
  secondary?: React.ReactNode;
  /** Optional: Symbol als Kachel links neben Titel und Wert (Gestaltung wie `layout/StatCard`). */
  icon?: React.ReactNode;
  /** Hervorhebung einer Kennzahl je Übersicht: `accent` färbt die Symbolkachel in der Akzentfarbe des Themes. */
  tone?: "default" | "accent";
};

/**
 * Einheitlicher Inhalt für Statistik-Karten (eine große Zahl + optional Suffix/Secondary).
 * Wird in Card verwendet – z. B. Dashboard und Personen/Übersicht.
 */
export function StatCardContent({ title, value, suffix, secondary, icon, tone = "default" }: StatCardContentProps) {
  const content = (
    <div style={{ minWidth: 0, overflowWrap: "anywhere" }}>
      <Statistic title={title} value={value as React.ComponentProps<typeof Statistic>["value"]} suffix={suffix} />
      {secondary != null && secondary !== false && (
        <div style={{ marginTop: spacing.sm, fontSize: typography.fontSize.secondary, color: "var(--ant-color-text-secondary)" }}>
          {secondary}
        </div>
      )}
    </div>
  );
  if (icon == null) return content;
  return (
    <div className={tone === "accent" ? "mq-stat-content mq-stat-card--accent" : "mq-stat-content"}>
      <span className="mq-stat-card-icon" aria-hidden>{icon}</span>
      {content}
    </div>
  );
}
